import VectorModule from '../Layer/VectorModule';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import OlCore from '../OlCore';
import GeoJSONFormat from 'ol/format/GeoJSON';
import * as loadingstrategy from 'ol/loadingstrategy';

import { click, platformModifierKeyOnly, shiftKeyOnly } from 'ol/events/condition';
import { Collection, Feature } from 'ol';
import { getPointsUrl, getPointUrl } from 'service/point';
import { shapeStyle, withTextStyle, withTextStyle2 } from 'ol/Style/PointStyle';
import { DragBox, Select, Modify, Snap } from 'ol/interaction';

import PointModule from 'ol/Layer/PointModule';
import { getWidth } from 'ol/extent';
import axios from 'axios';
import { Point } from 'ol/geom';
import Style from 'ol/style/Style';
import { Circle, Fill } from 'ol/style.js';
import { Text } from 'ol/style';
import { transform } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';

class ObjectPoint extends PointModule {
  private StandardPointLayer: VectorLayer<VectorSource>;

  public DogeunLayer: VectorLayer<VectorSource>;
  private DogeunSource!: VectorSource;
  public DogeunLayer2: VectorLayer<VectorSource>;
  private DogeunSource2!: VectorSource;

  private TriangleLayer!: VectorLayer<VectorSource>;
  private TriangleSource!: VectorSource;
  private TriangleLayer2!: VectorLayer<VectorSource>;
  private TriangleSource2!: VectorSource;

  private AssistantLayer!: VectorLayer<VectorSource>;
  private AssistantSource!: VectorSource;
  private AssistantLayer2!: VectorLayer<VectorSource>;
  private AssistantSource2!: VectorSource;

  private clickEvent!: Select;
  private standardClickEvent!: Select;

  constructor(core: OlCore) {
    super(core);
    // 지적도근점 레이어
    this.StandardPointLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'StandardPointLayer',
      },
      visible: true,
      zIndex: 9,
      // minZoom: 16.5,
      // maxZoom: Infinity,
    });
    // 지적도근점 레이어
    this.DogeunLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'DogeunLayer',
      },
      visible: false,
      zIndex: 9,
      // minResolution: 0,
      // maxResolution: 0.0001,
      minZoom: 16.5,
      maxZoom: Infinity,
    });
    this.DogeunLayer2 = new VectorLayer<VectorSource>({
      properties: {
        id: 'DogeunLayer2',
      },
      visible: false,
      zIndex: 9,
      // minResolution: 0,
      // maxResolution: 0.0001,
      minZoom: 16.5,
      maxZoom: Infinity,
    });

    // 지적삼각점 레이어
    this.TriangleLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'TriangleLayer',
      },
      visible: false,
      zIndex: 9,
      minZoom: 13.5,
      maxZoom: Infinity,
    });
    this.TriangleLayer2 = new VectorLayer<VectorSource>({
      properties: {
        id: 'TriangleLayer2',
      },
      visible: false,
      zIndex: 9,
      minZoom: 13.5,
      maxZoom: Infinity,
    });

    // 지적보조점 레이어
    this.AssistantLayer = new VectorLayer<VectorSource>({
      properties: {
        id: 'AssistantLayer',
      },
      visible: false,
      zIndex: 9,
      minZoom: 13.5,
      maxZoom: Infinity,
    });
    this.AssistantLayer2 = new VectorLayer<VectorSource>({
      properties: {
        id: 'AssistantLayer2',
      },
      visible: false,
      zIndex: 9,
      minZoom: 13.5,
      maxZoom: Infinity,
    });

    this.setLayers([this.StandardPointLayer, this.DogeunLayer, this.TriangleLayer, this.AssistantLayer, this.DogeunLayer2, this.TriangleLayer2, this.AssistantLayer2]);
  }

  /* ---------------- DRAW ---------------- */

  // 지적도근점 - GeoServer 파일 요청 데이터
  public draw(data: any) {
    const geoData = data.features;

    const features: any = this.createPointFeatures(geoData);

    const source = this.createSource(features);

    this.StandardPointLayer.setSource(source);
    this.StandardPointLayer.setStyle((feature) => shapeStyle(feature, 'circle'));
  }

  // 지적도근점 WFS - Dogeun
  public drawDogeun() {
    this.DogeunSource = new VectorSource({
      format: new GeoJSONFormat(),
      // url: function (extent) {
      //   let pointUrl = getPointUrl({ key: 'Dogeun', bbox: extent });
      //   return pointUrl;
      // },
      loader: async (extent, resolution, projection, success: any, failure: any) => {
        let pointUrl = getPointUrl({ key: 'Dogeun', bbox: extent });
        let response = await axios.get(pointUrl);

        //피쳐 배열 생성 후 벡터소스에 추가
        const features = this.DogeunSource?.getFormat()?.readFeatures(response.data) || [];

        if (features.length > 0) {
          // * 중복 피쳐 필터링 * //
          const key = 'src_objectid';
          // 1) 기존 도근점의 src_objectid 배열
          let ids = new Set(this.DogeunSource.getFeatures().map((feature) => feature.getProperties()?.[key]));
          // 2) 새로 요청한 response에서 기존에 없던 항목만 필터링
          const newFeatures: any[] = features.filter((feature) => !ids.has(feature.getProperties()?.[key]));

          this.DogeunSource.addFeatures(newFeatures);
          //  console.log(this.DogeunSource.getFeatures());
        }
      },
      strategy: loadingstrategy.bbox,
    });

    this.DogeunLayer.setSource(this.DogeunSource);
    this.DogeunLayer.setStyle((feature) => withTextStyle(feature));
  }

  // 지적삼각점 WFS - Triangle
  public drawTriangle() {
    this.TriangleSource = new VectorSource({
      format: new GeoJSONFormat(),
      // url: function (extent) {
      //   let pointUrl = getPointUrl({ key: 'Triangle', bbox: extent });
      //   return pointUrl;
      // },
      loader: async (extent, resolution, projection, success: any, failure: any) => {
        let pointUrl = getPointUrl({ key: 'Triangle', bbox: extent });
        let response = await axios.get(pointUrl);

        //피쳐 배열 생성 후 벡터소스에 추가
        const features = this.TriangleSource?.getFormat()?.readFeatures(response.data) || [];

        if (features.length > 0) {
          // * 중복 피쳐 필터링 * //
          const key = 'src_objectid';
          let ids = new Set(this.TriangleSource.getFeatures().map((feature) => feature.getProperties()?.[key]));
          const newFeatures: any[] = features.filter((feature) => !ids.has(feature.getProperties()?.[key]));

          this.TriangleSource.addFeatures(newFeatures);
        }
      },
      strategy: loadingstrategy.bbox,
    });

    this.TriangleLayer.setSource(this.TriangleSource);
    this.TriangleLayer.setStyle((feature) => withTextStyle(feature));
  }

  // 지적삼각보조점 WFS - Assistant
  public drawAssistant() {
    this.AssistantSource = new VectorSource({
      format: new GeoJSONFormat(),
      // url: function (extent) {
      //   return getPointUrl({ key: 'Assistant', bbox: extent });
      // },
      loader: async (extent, resolution, projection, success: any, failure: any) => {
        let pointUrl = getPointUrl({ key: 'Assistant', bbox: extent });
        let response = await axios.get(pointUrl);

        //피쳐 배열 생성 후 벡터소스에 추가
        const features = this.AssistantSource?.getFormat()?.readFeatures(response.data) || [];

        if (features.length > 0) {
          // * 중복 피쳐 필터링 * //
          const key = 'src_objectid';
          let ids = new Set(this.AssistantSource.getFeatures().map((feature) => feature.getProperties()?.[key]));
          const newFeatures: any[] = features.filter((feature) => !ids.has(feature.getProperties()?.[key]));

          this.AssistantSource.addFeatures(newFeatures);
        }
      },
      strategy: loadingstrategy.bbox,
    });

    this.AssistantLayer.setSource(this.AssistantSource);
    this.AssistantLayer.setStyle((feature) => withTextStyle(feature));
  }

  public drawEastArea(data) {
    const features = this.createStandardPointFeatures(data);
    const dogeunFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적도근점');
    const triFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적삼각점');
    const auxTriFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적삼각보조점');

    this.DogeunSource = this.createSource(dogeunFeature);
    this.DogeunLayer.setSource(this.DogeunSource);
    this.DogeunLayer.setStyle((feature) => withTextStyle2(feature, 'dogeun'));

    this.TriangleSource = this.createSource(triFeature);
    this.TriangleLayer.setSource(this.TriangleSource);
    this.TriangleLayer.setStyle((feature) => withTextStyle2(feature, 'triangle'));

    this.AssistantSource = this.createSource(auxTriFeature);
    this.AssistantLayer.setSource(this.AssistantSource);
    this.AssistantLayer.setStyle((feature) => withTextStyle2(feature, 'aux_triangle'));
  }
  public drawCenterArea(data) {
    const features = this.createStandardPointFeatures(data);
    const dogeunFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적도근점');
    const triFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적삼각점');
    const auxTriFeature = features.filter((feature) => feature.getProperties().properties.BASE_NAME === '지적삼각보조점');

    this.DogeunSource2 = this.createSource(dogeunFeature);
    this.DogeunLayer2.setSource(this.DogeunSource2);
    this.DogeunLayer2.setStyle((feature) => withTextStyle2(feature, 'dogeun'));

    this.TriangleSource2 = this.createSource(triFeature);
    this.TriangleLayer2.setSource(this.TriangleSource2);
    this.TriangleLayer2.setStyle((feature) => withTextStyle2(feature, 'triangle'));

    this.AssistantSource2 = this.createSource(auxTriFeature);
    this.AssistantLayer2.setSource(this.AssistantSource2);
    this.AssistantLayer2.setStyle((feature) => withTextStyle2(feature, 'aux_triangle'));
  }

  public arr: any = [];
  /* ---------------- EVENT ---------------- */

  //포인트 클릭
  public onClickPoint(setState) {
    const nameReturn = (feature) => {
      //  if (String(prop.getId()).split('.')[0] === 'dt_d007') {
      if (feature.getProperties().properties.BASE_NAME === '지적도근점') {
        return 'dogeun';
        //  } else if (String(prop.getId()).split('.')[0] === 'dt_d008') {
      } else if (feature.getProperties().properties.BASE_NAME === '지적삼각보조점') {
        return 'aux_triangle';
        //  } else if (String(prop.getId()).split('.')[0] === 'dt_d009') {
      } else if (feature.getProperties().properties.BASE_NAME === '지적삼각점') {
        return 'triangle';
      }
    };

    this.clickEvent = new Select({
      layers: [this.DogeunLayer, this.TriangleLayer, this.AssistantLayer, this.DogeunLayer2, this.TriangleLayer2, this.AssistantLayer2],
      condition: click,
      style: (feature) => withTextStyle2(feature, nameReturn(feature), true),
      multi: true, // 다중 선택 활성화
    });
    this.clickEvent.set('type', 'point');
    this.clickEvent.on('select', (e) => {
      setState((prevState) => {
        const newState = [...prevState];
        e.selected.forEach((feature) => {
          if (!newState.includes(feature)) {
            newState.push(feature);
          }
        });
        e.deselected.forEach((feature) => {
          const index = newState.indexOf(feature);
          if (index > -1) {
            newState.splice(index, 1);
          }
        });
        return newState;
      });
    });

    this.core.mapInstance.addInteraction(this.clickEvent);
  }

  public onClickStandard(api) {
    this.standardClickEvent = new Select({
      layers: [this.StandardPointLayer],
      condition: click,
    });
    this.core.mapInstance.addInteraction(this.standardClickEvent);
    this.standardClickEvent.on('select', (e) => {
      api(e.selected[0]?.getProperties()?.CTRLPNT_NM);
    });
  }

  public onClickPointClear() {
    this.clickEvent.getFeatures().clear();
  }

  public onRemoveRow(feature) {
    this.clickEvent.getFeatures().remove(feature);
  }

  // Drag Box에 포함된 도근점 | 삼각점 | 삼각보조점 찾기
  public dragBoxPoint(setState) {
    //  원하는 Select (dragBox에 포함된 피쳐를 추가할 Select) (ex)this.clickEvent
    let selectedFeatures = this.clickEvent.getFeatures();

    // 참고) .ol-dragbox 클래스 사용(스타일 지정)
    const dragBox = new DragBox({
      className: 'ol-dragbox',
      condition: platformModifierKeyOnly, // Ctrl+drag
    });

    // 지도에 dragBox 인터렉션 추가
    this.core.mapInstance.addInteraction(dragBox);

    // 드래그 종료시
    dragBox.on('boxend', () => {
      const boxExtent = dragBox.getGeometry().getExtent();
      // console.log(boxExtent);

      // 도근점 레이어(Select)와 겹치는 피쳐 구하기
      const worldExtent_org = this.core.mapInstance.getView().getProjection().getExtent(); // 기존코드) Error....
      // const worldExtent = this.core.mapInstance.getView().getProjection().getDefaultTileGrid().getExtent();
      const worldExtent = this.core.mapInstance.getView().calculateExtent();

      const worldWidth = getWidth(worldExtent);
      const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
      const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);

      for (let world = startWorld; world <= endWorld; ++world) {
        const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
        const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
        const extent = [left, boxExtent[1], right, boxExtent[3]];

        // * dragBox extent와 겹치는 Feature 찾기 (targetSource: 원하는 벡터 소스 (ex) 도근점 레이어))
        // 기존 selectedFeatures에 없는 항목만! * //
        function getBoxFeatures(targetSource) {
          return targetSource.getFeaturesInExtent(extent).filter((feature: any) => !selectedFeatures.getArray().includes(feature) && feature.getGeometry().intersectsExtent(extent));
        }

        // 박스에 포함된 feature 배열
        const boxFeatures = [
          ...getBoxFeatures(this.DogeunSource),
          ...getBoxFeatures(this.TriangleSource),
          ...getBoxFeatures(this.AssistantSource),
          ...getBoxFeatures(this.DogeunSource2),
          ...getBoxFeatures(this.TriangleSource2),
          ...getBoxFeatures(this.AssistantSource2),
        ];
        console.log('boxFeatures', boxFeatures);

        setState(boxFeatures);

        // * 추가 조건) view가 비스듬히 회전한 경우
        const rotation = this.core.mapInstance.getView().getRotation();
        const oblique = rotation % (Math.PI / 2) !== 0; // 지도 view의 기울기 유무 구하기.
        // 기울기가 있으면
        if (oblique) {
          const anchor = [0, 0];
          const geometry = dragBox.getGeometry().clone(); // dragBox에도 기울기 추가
          geometry.translate(-world * worldWidth, 0);
          geometry.rotate(-rotation, anchor);
          const extent = geometry.getExtent(); // 기울기가 적용된 box의 extent값

          // boxFeatures의 feature에도 기울기 주기, extent 겹치는 feature의 경우
          boxFeatures.forEach(function (feature: any) {
            const geometry = feature.getGeometry().clone();
            geometry.rotate(-rotation, anchor);
            if (geometry.intersectsExtent(extent)) {
              selectedFeatures.push(feature); // selected에 feature 직접 추가.
            }
          });
        } else {
          // 기울기가 없으면
          selectedFeatures.extend(boxFeatures); // selected에  boxFeatures 추가.
        }
      }
    });

    // 드래그 시작시
    dragBox.on('boxstart', function () {
      selectedFeatures.clear(); // selected 피쳐 초기화
    });

    // Select 피쳐 추가 또는 삭제시
    selectedFeatures.on(['add', 'remove'], function () {
      const names = selectedFeatures.getArray().map((feature) => {
        return feature.get('lgstr_splmcpt_idntfc_nm') || feature.get('lgstr_tgspt_idntfc_nm') || feature.get('lgstr_trgltpt_no_nm');
      });
      console.log(names);
      if (names.length > 0) {
        //   infoBox.innerHTML = names.join(', ');
      } else {
        //   infoBox.innerHTML = 'None';
      }
    });
  }

  public addGeoJson5174(geojson: any) {
    const vectorSource = new VectorSource({
      features: new GeoJSON().readFeatures(geojson, {
        dataProjection: 'EPSG:5174',
        featureProjection: 'EPSG:5174', // 동일
      }),
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      zIndex: 999,
      style: new Style({
        image: new Circle({
          radius: 5,
          fill: new Fill({ color: 'red' }),
        }),
      }),
    });

    this.core.mapInstance.addLayer(vectorLayer);

    return vectorLayer;
  }
  public addGeoJson5186(geojson: any) {
    const vectorSource = new VectorSource({
      features: new GeoJSON().readFeatures(geojson, {
        dataProjection: 'EPSG:5186',
        featureProjection: 'EPSG:5186', // 동일
      }),
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      zIndex: 999,
      style: new Style({
        image: new Circle({
          radius: 5,
          fill: new Fill({ color: 'blue' }),
        }),
      }),
    });

    this.core.mapInstance.addLayer(vectorLayer);

    return vectorLayer;
  }
}

export default ObjectPoint;
